import axios, { AxiosResponse } from 'axios';

import MeasurementDeviceItem from '../models/data/MeasurementDeviceItem';
import MeasurementValues from '../models/data/MeasurementValues';
import SearchItemsRequest, {
  toSearchItemsRequestParams,
} from '../models/requests/SearchItemsRequest';
import SearchValuesRequest, {
  toSearchValuesRequestParams,
} from '../models/requests/SearchValuesRequest';
import { createRequestConfig } from './utils';

export function requestItems(
  url: string,
  params?: SearchItemsRequest,
): Promise<AxiosResponse<MeasurementDeviceItem[]>> {
  const config = createRequestConfig({
    params: toSearchItemsRequestParams(params),
  });
  return axios.get<MeasurementDeviceItem[]>(url, config);
}

export function requestValues(
  url: string,
  params?: SearchValuesRequest,
): Promise<AxiosResponse<MeasurementValues>> {
  const config = createRequestConfig({
    params: toSearchValuesRequestParams(params),
  });
  return axios.get<MeasurementValues>(url, config);
}

export function requestValuesCount(
  url: string,
  params?: SearchValuesRequest,
): Promise<AxiosResponse<number>> {
  const config = createRequestConfig({
    params: toSearchValuesRequestParams(params),
  });
  return axios.get<number>(url, config);
}
